﻿/*==================================================
 *  Common localization strings
 *==================================================
 */

Timeline.strings["ru"] = {
    wikiLinkLabel:  "обсудите"
};




//////////////////
// WEBPACK FOOTER
// ./app/insa-pivot/lib/simile-timeline/timeline_js/scripts/l10n/ru/timeline.js
// module id = 591
// module chunks = 3